import React, { useCallback, useEffect, useState } from 'react';
import { Container, IconButton, Typography } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { useDispatch, useSelector } from 'react-redux';
import { DataGrid } from '@material-ui/data-grid';
import ImageGallery from 'react-image-gallery';

import TableHeader from '../common/TableHeader';
import AddContracts from '../Forms/AddContracts';
import { ModalAction } from '../common/Modal';
import { ImagePreview, Title } from './style';

import { getContracts, getContractById, deleteContractById, createContract, updateContract } from '../../actions/Contracts';
import { Text } from '../common/NotificationTable/style';
import { Noresults } from '../../Layout/style';

const AdminContracts = () => {
  const dispatch = useDispatch();
  const { contracts, contractInfo,user } = useSelector(({ contracts,auth }) => ({
    contracts: contracts?.contracts || [],
    contractInfo: contracts?.contractInfo || [],
    user: auth?.userData?.userLogado?.adm_login || null
  }));

  const [modal, setModal] = useState({
    open: false,
    type: null,
    title: null,
    action: null,
    url: null,
  });
  const [formData, setFormData] = useState({});
  const [searchString, setSearchString] = useState('');
  const [filteredElements, setFilteredElements] = useState('');
  const [images, setImages] = useState([]);
  let valideFormData =
    (formData?.name && formData?.startDate && formData?.business && formData?.locale && formData?.firstImage) || formData?.secondImage || formData?.thirdImage;

  useEffect(() => {
    dispatch(getContracts());
  }, []);

  useEffect(() => {
    setFormData({ ...contractInfo });
  }, [contractInfo]);

  useEffect(() => {
    if (searchString?.length > 0) {
      setFilteredElements(
        contracts.filter((i) => {
          return i.name.toUpperCase().match(searchString.toUpperCase());
        }),
      );
    } else setFilteredElements(contracts);
  }, [contracts, searchString]);

  const handleAdd = useCallback(() => {
    dispatch(createContract({ ...formData, userWhoCreated: user })).then(() => closeAndUpdate());
  });

  const closeAndUpdate = useCallback(() => {
    dispatch(getContracts());
    setModal({ open: false, type: null, title: null, action: null });
    setFormData({});
  });

  const handleOpen = (row) => {
    setModal({ open: true, images: row ? true : false });
    if (row) {
      setImages([
        {
          original: row?.firstImage?.Location,
          thumbnail: row?.firstImage?.Location,
        },
        {
          original: row?.secondImage?.Location,
          thumbnail: row?.secondImage?.Location,
        },
        {
          original: row?.thirdImage?.Location,
          thumbnail: row?.thirdImage?.Location,
        },
      ]);
    }
  };

  const handleClose = () => {
    setModal({ open: false, type: null, images: false });
    setFormData({});
    setImages([]);
  };

  const handleEdit = useCallback(() => {
    let params = { id: contractInfo.id, userWhoModified: user};

    if (formData.name && formData.name !== contractInfo.name) params = { ...params, name: formData.name };
    if (formData.firstImage && formData.firstImage !== contractInfo.firstImage) params = { ...params, firstImage: formData.firstImage };
    if (formData.secondImage && formData.secondImage !== contractInfo.secondImage) params = { ...params, secondImage: formData.secondImage };
    if (formData.thirdImage && formData.thirdImage !== contractInfo.thirdImage) params = { ...params, thirdImage: formData.thirdImage };
    if (formData.startDate && formData.startDate !== contractInfo.startDate) params = { ...params, startDate: formData.startDate };
    if (formData.business && formData.business !== contractInfo.business) params = { ...params, business: formData.business };
    if (formData.locale && formData.locale !== contractInfo.locale) params = { ...params, locale: formData.locale };

    dispatch(updateContract(params)).then(() => closeAndUpdate());
  });

  const columns = [
    {
      field: 'name',
      flex: 2,
      headerName: 'Cliente',
      sortable: true,
      renderCell: ({ row }) => <Text>{row.name}</Text>,
    },
    {
      field: 'files',
      flex: 3,
      renderCell: ({ row }) => (
        <>
          {row.firstImage?.Location && <ImagePreview onClick={() => handleOpen(row)} src={row.firstImage?.Location} />}
          {row.secondImage?.Location && <ImagePreview onClick={() => handleOpen(row)} src={row.secondImage?.Location} />}
          {row.thirdImage?.Location && <ImagePreview onClick={() => handleOpen(row)} src={row.thirdImage?.Location} />}
        </>
      ),
      headerName: 'Preview',
    },
    {
      field: 'startDate',
      flex: 1,
      headerName: 'Inicío',
      renderCell: ({ row }) => <Text>{row.startDate}</Text>,
    },
    {
      field: 'business',
      flex: 1,
      headerName: 'Negócio',
      renderCell: ({ row }) => <Text>{row.business}</Text>,
    },
    {
      field: 'locale',
      flex: 1,
      headerName: 'Localização',
      renderCell: ({ row }) => <Text>{row.locale}</Text>,
    },
    {
      field: 'actions',
      headerName: 'Açoes',
      flex: 1.2,
      sortable: false,
      renderCell: ({ row }) => (
        <>
          <IconButton
            onClick={() => {
              dispatch(getContractById(row.id)).then(() =>
                setModal({
                  open: true,
                  type: 'edit',
                  title: 'Editar Contrato',
                }),
              );
            }}
          >
            <FontAwesomeIcon icon={faEdit} />
          </IconButton>
          <IconButton
            onClick={() =>
              setModal({
                open: true,
                type: 'del',
                title: 'Deletar Contrato',
                action: () => {
                  dispatch(deleteContractById(row.id)).then(() => closeAndUpdate());
                },
              })
            }
          >
            <FontAwesomeIcon icon={faTrashAlt} />
          </IconButton>
        </>
      ),
    },
  ];

  return (
    <>
      <Container>
        <Title variant="h2">Gestão de Contratos</Title>
        <TableHeader
          setSearchString={setSearchString}
          placeholder="Pesquisar por Nome"
          btnAction={() =>
            setModal({
              open: true,
              type: 'add',
              title: 'Adicionar Contrato',
              action: () => handleAdd(),
            })
          }
        />
        <div style={{ height: 500, width: '100%', background: 'white' }}>
          <DataGrid
           components={{
            NoRowsOverlay: () => (
              <Noresults>
                <span>
                  Resultados não encontrado
                </span>
              </Noresults>
            ),
          }}
            pageSize={10}
            disableSelectionOnClick
            disableColumnMenu
            hideFooterSelectedRowCount
            rows={filteredElements.length ? filteredElements : []}
            columns={columns}
            rowHeight={100}
          />
        </div>
      </Container>
      <ModalAction
        title={modal?.title || ' '}
        successAction={modal?.type === 'add' ? () => handleAdd() : modal?.type === 'edit' ? () => handleEdit() : modal?.action}
        open={modal?.open}
        successActive={modal?.type === 'add' || modal?.type === 'edit' ? (valideFormData ? true : false) : true}
        successLabel={(modal?.type === 'del' && 'Deletar') || (modal.type === 'edit' && 'Alterar')}
        backAction={() => handleClose()}
      >
        {modal?.type === 'add' && <AddContracts formData={formData} setFormData={setFormData} />}
        {modal?.type === 'edit' && <AddContracts formData={formData} setFormData={setFormData} />}
        {modal?.type === 'del' && <Typography>Tem certeza que deseja deletar o Contrato?</Typography>}
        {modal?.images && <ImageGallery items={images} />}
      </ModalAction>
    </>
  );
};

export default AdminContracts;
